import 'es6-promise/auto';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Vue from 'vue/dist/vue.esm.js';
import axios from 'axios';

document.addEventListener('DOMContentLoaded', () => {
  const element = document.getElementById('discount-coupon-wrapper');

  /* eslint no-new: 0 */

  if (element != null) {
    new Vue({
      el: '#discount-coupon-wrapper',
      data() {
        return {
          messages: {
            invalid: '',
            valid: '',
          },
          validationMessage: null,
          validationClass: null,
          courseId: null,
          promoCodePath: null,
          promoCode: '',
          promoCodeUsed: false,
          percentageDiscount: false,
        };
      },
      methods: {
        getDiscountAmount(promoCode) {
          if (promoCode.discount !== 0) {
            this.percentageDiscount = true;
            const price = $('.order-wrapper').data('price');
            return (price * promoCode.discount) / 100;
          }

          this.percentageDiscount = false;
          return promoCode.discount_czk;
        },
        setDiscount(amount) {
          $('.order-wrapper').data('percentageDiscount', this.percentageDiscount);
          $('.order-wrapper').data('discount', amount);
          $(document).trigger('updateDiscount');
        },
        setMessage(type) {
          this.validationMessage = this.messages[type];
          this.validationClass = type === 'valid' ? 'alert alert-success' : 'alert alert-danger';
        },
        resetMessage() {
          this.validationMessage = null;
          this.validationClass = null;
        },
        removeCode(e) {
          e.preventDefault();
          this.promoCode = '';
          this.promoCodeUsed = false;
          this.resetMessage();
          this.setDiscount(0);
        },
        checkCode(e) {
          e.preventDefault();
          if (this.promoCode.length === 0) {
            return;
          }

          axios.post(this.promoCodePath, { course_id: this.courseId, promo_code: this.promoCode }).then((response) => {
            const { usable, promoCode } = response.data;
            if (usable) {
              this.setDiscount(this.getDiscountAmount(promoCode));
              this.promoCodeUsed = true;
              this.setMessage('valid');
            } else {
              this.promoCodeUsed = false;
              this.setDiscount(0);
              this.setMessage('invalid');
            }
          });
        },
      },
      mounted() {
        const {
          course_id, promocode_path, invalid, valid,
        } = element.dataset;

        this.courseId = course_id;
        this.messages.invalid = invalid;
        this.messages.valid = valid;
        this.promoCodePath = promocode_path;
      },
    });
  }
});
